<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card(min-height="80vh")
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic100}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('reminders') }}
        v-card-text(style="padding-bottom:90px")
          credit-alert(:credit="creditBalance" :showTitle="true")
          v-layout.my-12(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          div(v-else)
            div(v-if="yBooksSubscription.limitations.reminder > 0 && reminders.length > 0" )
              v-card(style="width:100%"  flat  v-for="(reminder,index) in reminders" :key="index")
                v-divider.mb-4(v-if="!isSameWeek(index) && !isFirstDate(index)" style="style")
                reminder-item.mb-2(:reminder='reminder' :isFirstDate='isFirstDate(index)' @stopped="fetchSchedules()")
              v-row
                v-col.pa-1.text-end
                  span.c2.primary400--text {{prev ? 'Past 30 days' : 'None'}}
                v-col.py-1.px-0.text-center(style="max-width:60px")
                  v-btn.mr-1.rounded-l(:class="{ primary500: prev, primary300: !prev }" @click="goPast" tile icon height="24" width="24" :disabled="!prev")
                    eva-icon(style="padding-top: 2px; padding-right: 2px;" name="arrow-ios-back-outline" height="14" :fill="$vuetify.theme.themes[$theme].basic100")
                  v-btn.ml-1.rounded-r(:class="{ primary500: next, primary300: !next }" @click="goNext" tile icon height="24" width="24" :disabled="!next")
                    eva-icon(style="padding-top: 2px; padding-right: 2px;" name="arrow-ios-forward-outline" height="14" :fill="$vuetify.theme.themes[$theme].basic100")
                v-col.pa-1.text-start
                  span.c2.primary400--text {{next ? 'Next 30 days' : 'None'}}
            div(v-else-if="yBooksSubscription.limitations.reminder <= 0")
              v-card.ma-auto.pa-4(outlined)
                v-card-text.text-center(style="height: 150px")
                  .p1.primary400--text Add-on feature
                  eva-icon.mx-auto(
                    name="calendar-outline",
                    :fill="$vuetify.theme.themes[$theme].info400",
                    width="36",
                    height="40"
                  )
                  .s1.primary500--text {{ $t('reminder_scheduling') }}
                  .p2.primary500--text {{ $t('reminder_scheduling_text') }}
                v-card-actions.text-center(style="display: grid")
                  .p2.primary400--text {{ $t('reminder_scheduling_price') }}
                  v-btn.mx-auto.mt-4.mb-2(
                    @click="yBooksSubscription.value ? showSubscribeAddOnReminderModal = true : showSubscribeBookModal = true",
                    outlined,
                    height="32",
                    style="background-color: var(--v-infoT08)", 
                    color="info500"
                  )
                    .button-AA-small.info500--text {{ $t('get_reminder_scheduling') }}
                  //- v-btn.mx-auto(
                  //-   @click="showModal = !showModal",
                  //-   text,
                  //-   depressed,
                  //-   height="32",
                  //- )
                  //-   .button-Aa-small.info500--text Learn more
            div(v-else-if="reminders.length == 0")
              v-row.align-center.ma-0.px-4.py-1(style="background-color: var(--v-basic600T08); margin:0 -24px 16px !important;")
                v-col.ma-0.pa-0.px-2
                  .s2.primary400--text {{ currentMonthYear }}
              .content.text-center.mt-8
                eva-icon.mx-auto.mt-4(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].info400" width="36" height="40")
                .p1.primary400--text.mt-4 {{ $t('no_reminders_yet') }}
                v-btn.mt-4(color="info500" dark @click="showScheduleReminderDialog=true" depressed height=32)
                  .button-AA-small.basic100--text {{ $t('schedule_a_reminder') }}
            
        v-btn.mr-3.mb-6(v-if="yBooksSubscription.limitations.reminder <= 0" color='textColorAccent' dark fab height="60" width="60" @click="showSendReminderDialog = true" style="position: absolute; bottom: 0; right: 0")
          eva-icon(name="plus-outline" :fill="$vuetify.theme.themes[$theme].basic100" height="24" width="24")
        v-menu(v-else)
          template(v-slot:activator='{ on }')
            v-btn.mr-3.mb-6(color='textColorAccent' dark fab height="60" width="60" v-on='on' style="position: absolute; bottom: 0; right: 0")
              eva-icon(name="plus-outline" :fill="$vuetify.theme.themes[$theme].basic100" height="24" width="24")
          v-list.pa-0
            v-list-item(@click="showSendReminderDialog = true")
              v-list-item-content
                v-list-item-title
                  .s2.basic800--text| {{ $t('send_reminder') }}
            v-list-item(@click="showScheduleReminderDialog = true")
              v-list-item-content
                v-list-item-title
                  .s2.basic800--text| {{ $t('schedule_reminder') }}
    .modals
      send-reminder(v-if="showSendReminderDialog" :open.sync="showSendReminderDialog" :credit.sync="creditBalance")
      schedule-reminder(v-if="showScheduleReminderDialog" :open.sync="showScheduleReminderDialog" :credit.sync="creditBalance" :type="null")
      subscribe-book-modal(v-if="showSubscribeBookModal" :open.sync="showSubscribeBookModal" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')")
      subscribe-add-on-reminder-modal(v-if="showSubscribeAddOnReminderModal" :open.sync="showSubscribeAddOnReminderModal" :company="company" @subscribed="$store.commit('subscriptions/update')")
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters, mapState } from 'vuex'
import ReminderItem from '@/components/yezzabook/dialogs/ReminderItem.vue'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'
import SendReminder from '@/components/yezzabook/dialogs/SendReminder.vue'
import ScheduleReminder from '@/components/yezzabook/dialogs/ScheduleReminder.vue'
import SubscribeBookModal from '@/components/billing/SubscribeBookModal.vue'
import SubscribeAddOnReminderModal from '@/components/billing/SubscribeAddOnReminderModal.vue'

export default {
  name: 'RemindersDialog',
  components:{ ReminderItem, CreditAlert, SendReminder, ScheduleReminder, SubscribeBookModal, SubscribeAddOnReminderModal },
  props: ['open'],
  data: () => ({
    isFetching: false,
    showSendReminderDialog: false,
    showScheduleReminderDialog: false,
    showSubscribeBookModal: false,
    showSubscribeAddOnReminderModal: false,
    reminders: [],
    // hasReminder: 0,
    fromDays: -30,
    toDays: 0,
    fromDate:'',
    toDate:'',
    prev: false,
    next: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    ...mapState('subscriptions', ['yBooksSubscription']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    creditBalance () {
      return this.company.prepaid_credits
    },
    currentMonthYear () {
      const date = DateTime.local()
      return `${date.monthLong} ${date.year}`
    }
  },
  watch: {
    showModal(visible) {
      if (visible) {
        this.fetchSchedules()
      }
    }
  },
  mounted () {
    // this.fetchSchedules()
    // this.hasReminder = this.reminders.length
    // for (let i = 0; i < this.reminders.length; i++) {
    //   const data = this.reminders[i]
    //   const groupId = data.date
    //   let groupIsExist = false
    //   for (let j = 0; j < this.reminderList.length; j++) {
    //       const group = this.reminderList[j]
    //       if (group.id === groupId) {
    //           groupIsExist = true
    //           this.reminderList[j].items.push(data)
    //       }
    //   }
    //   if (groupIsExist) continue
    //   const newItems = []
    //   newItems.push(this.reminders[i])
    //   const newGroup = {
    //       id: groupId,
    //       items: newItems,
    //   }
    //   this.reminderList.push(newGroup)
    // }
    // this.reminderList.sort(this.compareGroup)
    // for (let k = 0; k < this.reminderList.length; k++) {
    //     this.reminderList[k].items.sort(this.compareDate)
    // }
  },
  methods:{
    fetchSchedules() {
      if (this.yBooksSubscription.limitations.reminder <= 0) {
        return
      }
      this.isFetching = true
      // console.log(this.isFetching);
      this.fromDate = this.countDate('past',this.fromDays + 30)
      this.toDate = this.countDate('next',this.toDays + 30)
      let url = `/books/${this.company.slug}/scheduled_reminders/schedules?from=${this.fromDate}&until=${this.toDate}&expand=income,expense.category_items,expense.category_items.category`
      this.$axios.get(url).then((response) => {
        let array = []
        array = {...response}
        this.reminders = [...array.data]
        this.isFetching = false
      }).catch(() => {})
      this.checkBefore()
      this.checkAfter()
    },
    goNext() {
      this.fromDays -= 31
      this.toDays += 31
      this.fetchSchedules()
    },
    goPast() {
      this.fromDays += 31
      this.toDays -= 31
      this.fetchSchedules()
    },
    checkBefore(){
      var fromDate = this.countDate('past',this.fromDays + 31 + 30)
      var toDate = this.countDate('next',this.toDays - 31 + 30)
      let url = `/books/${this.company.slug}/scheduled_reminders/schedules?from=${fromDate}&until=${toDate}&expand=income,expense.category_items,expense.category_items.category`
      this.$axios.get(url).then((response) => {
        let array = []
        let data
        array = {...response}
        data = [...array.data]
        if (data.length) {
          this.prev = true
        }else{
          this.prev = false
        }
      }).catch(() => {})
    },
    checkAfter(){
      var fromDate = this.countDate('past',this.fromDays - 31 + 30)
      var toDate = this.countDate('next',this.toDays + 31 + 30)
      let url = `/books/${this.company.slug}/scheduled_reminders/schedules?from=${fromDate}&until=${toDate}&expand=income,expense.category_items,expense.category_items.category`
      this.$axios.get(url).then((response) => {
        let array = []
        let data
        array = {...response}
        data = [...array.data]
        if (data.length) {
          this.next = true
        }else{
          this.next = false
        }
      }).catch(() => {})
    },
    getWeek(date) {
      // var data = date.split('-')
      var newDate = new Date(date)
      var firstDayOfYear =  new Date(newDate.getFullYear(), 0, 1);
      var pastDaysOfYear =  (newDate.valueOf() - firstDayOfYear.valueOf()) / 86400000
      var result = Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() - 1) / 7);
      // console.log(date+' '+result);
      return result
    },
    isFirstDate(index){
      var indexBefore = index - 1
      if (indexBefore < 0) {
        return true
      }else{
        var month = this.reminders[index].date.toString().split('-')[1]
        var monthBefore = this.reminders[indexBefore].date.toString().split('-')[1]
        if (month == monthBefore) {
          return false
        }else{
          return true
        }
      }
    },
    isSameWeek(index){
      var indexBefore = index - 1
      if (indexBefore < 0) {
        return true
      }else{
        var date = this.reminders[index].date
        var week = this.getWeek(date)
        // console.log(date);
        // console.log(week);
        var dateBefore = this.reminders[indexBefore].date
        var weekBefore = this.getWeek(dateBefore)
        // console.log(dateBefore);
        // console.log(weekBefore);
        // console.log('-----');
        if (week == weekBefore) {
          return true
        }else{
          return false
        }
      }
    },
    countDate(sit,count){ //sit = past/next
      var date = new Date();
      if (sit == 'past') {
        date.setDate(date.getDate() - count);
      } else if (sit == 'next') {
        date.setDate(date.getDate() + count);
      } else {
        date.setDate(date.getDate());
      }
      return date = date.toISOString().split('T')[0]; // "yyyy-mm-dd"
    }
    // compareGroup(a, b) {
    //   const A = a.id
    //   const B = b.id
    //   let comparison = 0
    //   if (A > B) {
    //     comparison = 1
    //   } else if (A < B) {
    //     comparison = -1
    //   }
    //   return comparison
    // },
    // compareDate(a, b) {
    //   const A = a.date
    //   const B = b.date
    //   let comparison = 0
    //   if (A > B) {
    //     comparison = 1
    //   } else if (A < B) {
    //     comparison = -1
    //   }
    //   return comparison
    // },
  },
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "reminder_scheduling": "Reminder Scheduling",
    "reminder_scheduling_text": "Schedule reminders in advance and view reminder history so you never miss a payment",
    "reminder_scheduling_price": "RM 5.00 / month",
    "get_reminder_scheduling": "Get reminder scheduling",
    "no_reminders_yet": "No reminders yet",
    "schedule_a_reminder": "Schedule A reminder",
    "send_reminder": "Send reminder",
    "schedule_reminder": "Schedule reminder"
  },
  "id": {
  }
}
</i18n>
